import React, { createContext, useContext, useState, useEffect } from 'react';
import { adService } from '../services/adService';

const AdContext = createContext(null);

export function AdProvider({ children }) {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    adService.getActive()
      .then(data => setAds(Array.isArray(data) ? data : []))
      .catch(() => setAds([]));
  }, []);

  function getActiveAds(position) {
    return ads.filter(a => {
      if (!a.isActive) return false;
      if (!position) return true;
      if (position === 'top')        return a.position === 'top';
      if (position === 'bottom')     return a.position === 'bottom';
      if (position === 'left-full')  return a.position === 'left-full'  || a.position === 'both-full';
      if (position === 'right-full') return a.position === 'right-full' || a.position === 'both-full';
      return a.position === position || a.position === 'both';
    });
  }

  return (
    <AdContext.Provider value={{ getActiveAds }}>
      {children}
    </AdContext.Provider>
  );
}

export function useAds() {
  return useContext(AdContext);
}
